export default {
  PARENT: 'PARENT',
  INDEPENDENT: 'INDEPENDENT',
  CHILD: 'CHILD'
};
